import { DrawerCollapsible } from "components/UI/DrawerCollapsible/DrawerCollapsible.tsx";
import { PropertiesList } from "components/UI/PropertiesList/PropertiesList.tsx";
import { ShortenedTextWithCopy } from "components/UI/ShortenedTextWithCopy";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";

import ConversionStateData = App.Data.ConversionStateData;

interface LogCustomParametersSectionProps {
    conversion: ConversionStateData | undefined;
}

export const LogCustomParametersSection: FC<LogCustomParametersSectionProps> = ({ conversion }) => {
    const { t } = usePaldockTranslation("components.log-conversion-detail");

    return (
        <DrawerCollapsible title={t("sections.custom_parameters")} isDefaultOpen={false}>
            {conversion?.custom_data && Object.keys(conversion.custom_data).length > 0 ? (
                <PropertiesList
                    list={PropertiesList.create(
                        conversion.custom_data,
                        Object.entries(conversion.custom_data).map(([key, value]) => ({
                            term: key,
                            description: () =>
                                value !== null && value !== undefined
                                    ? Array.isArray(value)
                                        ? value.join(", ")
                                        : String(value)
                                    : "-",
                            render: () => {
                                if (value === null || value === undefined) return "-";
                                const textValue = Array.isArray(value) ? value.join(", ") : String(value);
                                return <ShortenedTextWithCopy text={textValue} />;
                            },
                        }))
                    )}
                />
            ) : (
                <div>{t("messages.no_conversion_custom_data")}</div>
            )}
        </DrawerCollapsible>
    );
};
